import * as types from "./actionTypes";

export const loadSubscriptionRequestsSuccess = (requests: any) => {
  return { type: types.LOAD_SUBSCRIPTIONREQUESTS_SUCCESS, requests };
}
export const loadSubscriptionRequestsSizeSuccess = (requests: any) => {
  return { type: types.LOAD_SUBSCRIPTIONREQUESTSSIZE_SUCCESS, requests };
}


export const loadSubscriptionRequestStart = (page?:number, pagesize?:number, environmentId?:number) => {
  return { type: types.START_LOAD_SUBSCRIPTIONREQUEST, page, pagesize ,environmentId };
}



// WEBPACK FOOTER //
// ./src/modules/core/actions/subscriptionRequestActions.tsx